import React, { useState, useEffect } from 'react';
import { PageHeader, Empty, Spin, Typography } from 'antd';
import { Select, Popover } from 'antd';
import { branchnetworkListService } from 'services/branchnetwork';
import { branchcustomerListByBranchNetworkIdService } from 'services/branchcustomer';
import { handleApiSuccess, handleApiError, accessControls } from 'utils';
import _ from 'lodash';
import { ArrowUpOutlined } from '@ant-design/icons';

import {
  usersSetLoginNetworkService,
  usersGetLoginNetworkService,
} from 'services/user';
import Auth from 'auth';

const { Title } = Typography;
const _auth = Auth;
const { Option } = Select;
export default function NetworkToolWrapper(props) {
  const [isClientLoading, setIsClientLoading] = useState(false);

  const [branchNetworkLoading, setBranchNetworkLoading] = useState(false);
  const [branchCustomerLoading, setBranchCustomerLoading] = useState(false);

  const [branchNetworkCurrent, setBranchNetworkCurrent] = useState(null);
  const [branchCustomerCurrent, setBranchCustomerCurrent] = useState(null);

  const [hideLocationDropdown, setHideLocationDropdown] = useState(false);

  const [isUpdating, setIsUpdating] = useState(false);

  const [branchNetwork, setBranchNetwork] = useState([]);
  const [branchCustomer, setBranchCustomer] = useState([]);

  useEffect(() => {
    setBranchNetworkLoading(true);
    branchnetworkListService()
      .then((response) => {
        setBranchNetworkLoading(false);
        if (response.data.items && response.data.items.length > 0) {
          let items = [];
          //console.log("response.data.items", response.data.items);
          response.data.items.map((item) => {
            // Only include active branch networks in the dropdown
            if (item.status === 'active' || !item.status) {
              items.push({
                _id: item._id,
                name: `${item.branch.branch_name} (${item.company.company_name})`,
              });
            }
            return false;
          });
          const sortedItems = _.orderBy(items, ['name'], ['asc']);
          setBranchNetwork(sortedItems);
        }
      })
      .catch((error) => {
        setBranchNetworkLoading(false);
        //handleApiError(error);
      });

    setIsClientLoading(true);
    usersGetLoginNetworkService()
      .then((response) => {
        console.log('usersGetLoginNetworkService-response', response.data);
        const item = response.data.item;
        if (item) {
          setHideLocationDropdown(item.hideLocationDropdown || false);
          setBranchNetworkCurrent(item.branchnetwork._id);
          branchNetworkChanged(item.branchnetwork._id).then(() => {
            //
          });
          if (item._id) {
            setBranchCustomerCurrent(item._id);
          }
        }
        setIsClientLoading(false);
      })
      .catch((error) => {
        setIsClientLoading(false);
        handleApiError(error);
      });
  }, []);

  const handelBranchNetworkChange = (value) => {
    setIsUpdating(true);
    branchNetworkChanged(value).then(() => {
      const payload = {
        locationId: value,
        customerId: null,
      };
      usersSetLoginNetworkService(payload)
        .then((response) => {
          _auth.authenticate(response.data.token, function () {
            handleApiSuccess(response);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          });
        })
        .catch((error) => {
          setIsUpdating(false);
          setBranchCustomerLoading(false);
          handleApiError(error);
        });
    });
  };

  const branchNetworkChanged = (value) => {
    console.log('branchNetworkChanged', value);
    return new Promise((resolve, reject) => {
      const branchNetworkId = value;
      setBranchNetworkCurrent(branchNetworkId);
      setBranchCustomerLoading(true);
      branchcustomerListByBranchNetworkIdService(branchNetworkId)
        .then((response) => {
          console.log('branchNetworkChanged-response', response.data);
          setBranchCustomerLoading(false);
          if (response.data.items && response.data.items.length > 0) {
            let items = [];
            response.data.items.map((item) => {
              items.push({
                _id: item._id,
                name: `${item.customername} (${item.accountnumber})`,
              });
              return false;
            });
            const sortedItems = _.orderBy(items, ['name'], ['asc']);
            console.log('response.data.items', response.data.items);
            setBranchCustomer(sortedItems);
          } else {
            setBranchCustomerCurrent(null);
            setBranchCustomer([]);
          }
          resolve(true);
        })
        .catch((error) => {
          console.log('branchNetworkChanged-error', error);
          setBranchCustomerLoading(false);
          reject(false);
          //handleApiError(error);
        });
    });
  };

  const branchCustomerChanged = (value) => {
    setIsUpdating(true);
    setBranchCustomerLoading(true);
    const branchCustomerId = value;
    setBranchCustomerCurrent(branchCustomerId);
    const payload = {
      locationId: branchNetworkCurrent,
      customerId: value,
    };
    usersSetLoginNetworkService(payload)
      .then((response) => {
        setBranchCustomerLoading(false);
        _auth.authenticate(response.data.token, function () {
          handleApiSuccess(response);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      })
      .catch((error) => {
        setIsUpdating(false);
        setBranchCustomerLoading(false);
        handleApiError(error);
      });
  };

  const AppBar = () => {
    return (
      <>
        <PageHeader
          className="site-page-header"
          onBack={null}
          title="Networking Tool"
          subTitle="Branch Network and Branch Client selection"
          extra={[
            <Popover
              key={'popover-1'}
              content={<p>Please select branch to load associated data</p>}
              title="Select branch network"
              open={false}
            >
              <Select
                showSearch
                placeholder="Select branch network"
                optionFilterProp="children"
                defaultValue={branchNetworkCurrent}
                value={branchNetworkCurrent}
                onChange={(value) => handelBranchNetworkChange(value)}
                style={{ width: 400, marginRight: 10 }}
                loading={branchNetworkLoading}
                disabled={hideLocationDropdown}
              >
                {branchNetwork.map((item, index) => (
                  <Option key={`branchNetwork-${index}`} value={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Popover>,
            props.isBranchClientRequired === false ? null : (
              <Popover
                key={'popover-2'}
                content={
                  <p>Please select Branch Client load associated data</p>
                }
                title="Select branch network"
                open={false}
              >
                <Select
                  showSearch
                  placeholder="Select Branch Client"
                  optionFilterProp="children"
                  defaultValue={branchCustomerCurrent}
                  value={branchCustomerCurrent}
                  onChange={(value) => branchCustomerChanged(value)}
                  style={{ width: 400 }}
                  loading={branchCustomerLoading}
                >
                  {branchCustomer.map((item, index) => (
                    <Option key={`branchClient-${index}`} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Popover>
            ),
          ]}
        />
      </>
    );
  };

  const View = () => {
    // Show loading animation while branch network is loading initially
    if (branchNetworkLoading && branchNetwork.length === 0) {
      return (
        <div style={{ margin: '30px', textAlign: 'center' }}>
          <Spin size="large" />
          <div style={{ marginTop: '16px' }}>
            <Title level={4}>Loading Branch Network...</Title>
          </div>
        </div>
      );
    }

    if (
      branchNetworkCurrent &&
      !isUpdating &&
      (branchCustomerCurrent || props.isBranchClientRequired === false)
    ) {
      return <div>{props.children}</div>;
    } else {
      if (isClientLoading || isUpdating) {
        return (
          <div style={{ margin: '30px', textAlign: 'center' }}>
            <Spin size="large" />
            <div style={{ marginTop: '16px' }}>
              <Title level={4}>Loading...</Title>
            </div>
          </div>
        );
      } else {
        return (
          <div style={{ backgroundColor: '#FFF', padding: '15px  0' }}>
            <Empty>
              <Title level={2}>
                {props.isBranchClientRequired === false
                  ? 'Please select Branch Network'
                  : 'Please select Branch Network and Branch Client'}
                <ArrowUpOutlined />
              </Title>
              <Title level={5}>
                This must be selected from above dropdowns before moving
                forward.
              </Title>
            </Empty>
          </div>
        );
      }
    }
  };

  return (
    <div style={{ marginTop: 15 }}>
      <div style={{ backgroundColor: '#FAFAFA' }}>
        <AppBar />
      </div>
      <div>
        <View />
      </div>
    </div>
  );
}
